import { lazy } from 'react';

const Art19 = lazy(() => import("./Art19"));
const Audioboom = lazy(() => import("./Audioboom"));
const Aushua = lazy(() => import("./Aushua"));
const Blubrry = lazy(() => import("./Blubrry"));
const Buzzsprout = lazy(() => import("./Buzzsprout"));
const Captivate = lazy(() => import("./Captivate"));
const Castos = lazy(() => import("./Castos"));
const Fireside = lazy(() => import("./Fireside"));
const Futuri = lazy(() => import("./Futuri"));
const Libsyn = lazy(() => import("./Libsyn"));
const Megaphone = lazy(() => import("./Megaphone"));
const Omny = lazy(() => import("./Omny"));
const Pinecast = lazy(() => import("./Pinecast"));
const Podbean = lazy(() => import("./Podbean"));
const PodcastCo = lazy(() => import("./PodcastCo"));
const Podcloud = lazy(() => import("./Podcloud"));
const RedCircle = lazy(() => import("./RedCircle"));
const Simplecast = lazy(() => import("./Simplecast"));
const Soundcloud = lazy(() => import("./Soundcloud"));
const Spreaker = lazy(() => import("./Spreaker"));
const Squarespace = lazy(() => import("./Squarespace"));
const StreamGuys = lazy(() => import("./StreamGuys"));
const Transistor = lazy(() => import("./Transistor"));

export const hostMap = {
    ACast: {
        supported: "NO"
    },
    Anchor: {
        supported: "NO"
    },
    Art19: {
        supported: "YES",
        instructions: Art19
    },
    Audioboom: {
        supported: "YES",
        instructions: Audioboom
    },
    Aushua: {
        supported: "YES",
        instructions: Aushua
    },
    Blubrry: {
        supported: "YES",
        instructions: Blubrry
    },
    Buzzsprout: {
        supported: "YES",
        instructions: Buzzsprout
    },
    Captivate: {
        supported: "YES",
        instructions: Captivate
    },
    Castos: {
        supported: "YES",
        instructions: Castos
    },
    "Fireside.fm": {
        supported: "YES",
        instructions: Fireside
    },
    Futuri: {
        name: "Futuri Media",
        supported: "YES",
        instructions: Futuri
    },
    Libsyn: {
        supported: "YES",
        instructions: Libsyn
    },
    Megaphone: {
        supported: "YES",
        instructions: Megaphone
    },
    "Nox Solutions": {
        supported: "UNKNOWN"
    },
    "Omny Studio": {
        name: "Omny/Triton",
        supported: "YES",
        instructions: Omny
    },
    Pinecast: {
        supported: "YES",
        instructions: Pinecast
    },
    PodBean: {
        name: "Podbean",
        supported: "YES",
        instructions: Podbean
    },
    "Podcast.co": {
        supported: "YES",
        instructions: PodcastCo
    },
    Podcloud: {
        supported: "YES",
        instructions: Podcloud
    },
    RedCircle: {
        supported: "YES",
        instructions: RedCircle
    },
    Simplecast: {
        supported: "YES",
        instructions: Simplecast
    },
    Soundcloud: {
        supported: "YES",
        instructions: Soundcloud
    },
    Spreaker: {
        supported: "YES",
        instructions: Spreaker
    },
    Squarespace: {
        supported: "YES",
        instructions: Squarespace
    },
    "Stream Guys": {
        supported: "YES",
        instructions: StreamGuys
    },
    Transistor: {
        supported: "YES",
        instructions: Transistor
    }
};

export function getHostMeta(hostKey) {
    const meta = hostMap[hostKey];
    return {
        name: meta?.name ?? hostKey,
        supported: meta?.supported ?? "UNKNOWN",
        instructions: meta?.instructions
    };
}
